import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

const RateTemplateProxy = {
    get: (obj, props) => {
        if (!(typeof props === 'string')) {
            return obj[props];
        }
        if (/^resolved_/.test(props)) {
            let property = props.replace('resolved_', '');
            return obj[property];
        }
        return obj[props];
    }
};

/**
 * RateTemplate.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class RateTemplate extends BaseAPIModel {
    constructor(...args) {
        let res = super(...args);
        return new Proxy(res, RateTemplateProxy);
    }

    fields() {
        return {
            uuid: { readOnly: true, primaryKey: true },
            name: {}
        };
    }

    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][RateTemplate][getAll] organizationId is mandatory');
        }
        return `/ticket/organizations/${organizationId}/rates`;
    }
}
